<template>
  <div class="cp-footer has-background-primary has-text-centered text-center">
    <div class="md-logo">
      <img src="https://ik.imagekit.io/osusf6xvdf/beta/logo-secondary_m_QrdfROWV-F.png" class="" width="150px">
    </div>
    <div class="md-text">
      <br><p>Madam Ranee Showroom 6/1-2 <br>
         Petchaburi Soi 19, Pratunam<br>
         Bangkok 10330 Thailand<br>
      </p>
    </div>
    <div class="md-contact">
          <br><p>Phone : (+66) 94 759 5111</p>
          <p>Email : <a href="mailto:madamranee.official@gmail.com">
            madamranee.official@gmail.com</a></p><br>
    </div>
    <!-- <div class="md-social" >
       <a href="" target="_blank">
        <img src="../assets/img/home/social-mail-icon.png">
      </a>
      <a href="" target="_blank">
        <img src="../assets/img/home/social-whatapp-icon.png">
      </a>
      <a href="https://web.facebook.com/madamraneesoap/?ref=page_internal"
        target="_blank">
        <img src="../assets/img/home/social-facebook-icon.png">
      </a>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import Contact from '@/components/Contact.vue';

export default {
  name: 'Footer',
  components: {
    // Contact,
  },
  computed: mapState({
    contact: state => state.contact,
    company: state => state.company,
  }),
};
</script>

<style lang="scss" scoped>
.md-logo{
}
.md-text{
  @media screen and (max-width: 768px) {
     padding-top: 20px;
    }
}
.md-contact{
  @media screen and (max-width: 768px) {
     padding-top: 20px;
    }
}
.md-social{
  @media screen and (max-width: 900px) {
      padding-top: 20px;
    }

  a{
     padding-left:20px;
  }

  img{
    height: 30px;
  }
}
.cp-footer {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 8%;
  padding-right: 8%;
  z-index: 99;
  position: absolute;
  width: 100%;
  // display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    position: relative;
  }

  &-about-section {
    width: calc(100% / 3);
    text-align: left;

    @media screen and (max-width: 768px) {
      width: 100%;
      text-align: center;
    }
  }

  &-navigation-section {
    width: calc(100% / 3);
    padding-left: 80px;
    text-align: left;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 768px) {
      width: 100%;
      text-align: center;
      padding-left: 0;
    }
  }

  &-social-media-section {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: calc(100% / 3);
    text-align: right;

    @media screen and (max-width: 768px) {
      width: 100%;
      text-align: center;
    }

    &-group {
      display: flex;
      justify-content: flex-end;

      @media screen and (max-width: 768px) {
        justify-content: center;
      }
    }

    img {
      cursor: pointer;
      height: 30px;
      margin-left: 10px;
    }
  }
}

.cp-footer-logo {
  height: 50px;
}
</style>
